(function () {
  'use strict';

  if (window.__cartImageLinkInitialised) return;
  window.__cartImageLinkInitialised = true;

  var CONFIG = {
    containerSelectors: [
      'cart-drawer',
      '#CartDrawer',
      '#main-cart-items',
      'cart-items'
    ],
    itemSelector: '.cart-item',
    imageSelector: '.cart-item__image, .cart-item__image-container img, .cart-item__media img',
    urlSelectors: [
      'a.cart-item__link[href]',
      'a.cart-item__name[href]',
      'a[href*="/products/"]'
    ],
    processedAttr: 'data-cart-image-link',
    debounceMs: 60
  };

  function isValidUrl(url) {
    if (!url) return false;
    var trimmed = url.trim();
    if (trimmed === '' || trimmed === '#') return false;
    if (trimmed.indexOf('javascript:') === 0) return false;
    return true;
  }

  function findProductUrl(itemEl) {
    for (var i = 0; i < CONFIG.urlSelectors.length; i++) {
      var el = itemEl.querySelector(CONFIG.urlSelectors[i]);
      if (el) {
        var href = el.getAttribute('href');
        if (isValidUrl(href)) return href;
      }
    }
    return null;
  }

  function hasAnchorAncestor(node, stopAt) {
    var el = node.parentElement;
    while (el && el !== stopAt) {
      if (el.tagName === 'A') return true;
      el = el.parentElement;
    }
    return false;
  }

  function wrapImage(img, url, productTitle) {
    var anchor = document.createElement('a');
    anchor.className = 'cart-item__image-link';
    anchor.href = url;
    anchor.style.display = 'contents';
    if (productTitle) {
      anchor.setAttribute('aria-label', productTitle);
    }

    img.parentNode.insertBefore(anchor, img);
    anchor.appendChild(img);

    img.setAttribute(CONFIG.processedAttr, 'true');
    img.classList.add('cart-item__image--linked');
  }

  function processCartItem(itemEl) {
    var images = itemEl.querySelectorAll(CONFIG.imageSelector);
    if (!images.length) return;

    var url = findProductUrl(itemEl);
    if (!url) return;

    var titleEl = itemEl.querySelector('.cart-item__name');
    var productTitle = titleEl ? titleEl.textContent.trim() : null;

    for (var i = 0; i < images.length; i++) {
      var img = images[i];

      if (img.getAttribute(CONFIG.processedAttr) === 'true') continue;

      if (hasAnchorAncestor(img, itemEl)) {
        img.setAttribute(CONFIG.processedAttr, 'true');
        continue;
      }

      wrapImage(img, url, productTitle);
    }
  }

  function processAllCartItems() {
    var items = document.querySelectorAll(CONFIG.itemSelector);
    for (var i = 0; i < items.length; i++) {
      processCartItem(items[i]);
    }
  }

  var debounceTimer = null;
  function scheduleRescan() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(processAllCartItems, CONFIG.debounceMs);
  }

  function observeContainer(container) {
    if (container.__cartImageLinkObserved) return;
    container.__cartImageLinkObserved = true;

    var observer = new MutationObserver(scheduleRescan);
    observer.observe(container, { childList: true, subtree: true });
  }

  function attachObservers() {
    for (var i = 0; i < CONFIG.containerSelectors.length; i++) {
      var el = document.querySelector(CONFIG.containerSelectors[i]);
      if (el) observeContainer(el);
    }
  }

  function init() {
    processAllCartItems();
    attachObservers();

    var bodyObserver = new MutationObserver(function () {
      attachObservers();
    });
    bodyObserver.observe(document.body, { childList: true, subtree: false });

    document.addEventListener('cart:refresh', processAllCartItems);
    document.addEventListener('cart:update', processAllCartItems);
    document.addEventListener('cart:updated', processAllCartItems);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// linked with layaut/theme